import { useFont } from '@octane/spark'
import styled from 'styled-components'

export const CommentsContainer = styled.div<{ isDecline?: boolean }>`
    background-color: ${({ isDecline }) =>
        isDecline ? 'rgba(217, 15, 3, 0.1)' : 'rgba(227, 163, 62, 0.1)'};
    border-radius: 5px;
    padding: 20px;
    text-align: left;
    width: 100%;
`

export const BoxHeader = styled.div`
    ${() => useFont('c16', { weight: '400' })}
    color: ${({ theme }) => theme.colors.monochrome.ravenSub};
`

export const CommentList = styled.ul`
    padding: 0;
    margin: 0;
`

export const CommentItem = styled.li<{ isDecline?: boolean }>`
    ${() => useFont('c16', { weight: '400' })}
    display: grid;
    grid-template-columns: 32px auto;
    list-style: none;
    margin-top: 10px;
    padding: 0;

    path {
        fill: ${({ isDecline }) =>
            isDecline ? 'rgba(213, 33, 22, 1)' : 'rgba(227, 163, 62, 1)'};
    }
`

export const CommentsSpinnerWrapper = styled.div`
    padding: 1em;
    width: 100%;
    display: flex;
    justify-content: center;
`
